import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';

const tutorInvoiceOpenFailedTemplate = ({ classes, notificationData }) => {
  const {
    dryRun,
    triggeredBy,
    runAt,
    invoiceId,
    userId,
    userName,
    error,
  } = notificationData;
  const runTime = runAt ? dayjs(runAt).format('DD MMMM YYYY HH:mm') : null;

  return (
    <>
      <Typography variant="body1" className={classes.author} component="div">
        <strong>Path Education</strong>
      </Typography>
      <Typography variant="body1" className={classes.message} component="div">
        Tutor draft invoice <strong>{invoiceId}</strong> for{' '}
        <strong>{userName}</strong> ({userId}) {dryRun ? 'would fail to open' : 'failed to open'}
        {triggeredBy?.name && <> by <strong>{triggeredBy.name}</strong></>}
        {runTime && <> on <strong>{runTime}</strong></>}.
      </Typography>
      <Typography variant="body2" className={classes.message} component="div">
        Reason: {error}
      </Typography>
    </>
  );
};

export default tutorInvoiceOpenFailedTemplate;
